import React from 'react'
import classNames from 'classnames'
import { formatDistanceToNow } from 'date-fns'

import Avatar from '../Avatar'
import { formatDistanceItem } from '../GridList/utils'
import './style.scss'

const Comment = ({ showAvatar, firstName, lastName, color, text, date, hideName, actions = [], formatter, contentClass, commentFooter }) => {

  return (
    <div className='viso-comment'>
      {showAvatar &&
        <div className='viso-comment__avatar'>
          <Avatar firstName={firstName} lastName={lastName} color={color} />
        </div>
      }

      <div className={classNames('viso-comment__content', contentClass)}>
        {!hideName && <div className='viso-comment__author'>{firstName} {lastName}</div>}
        <div className='viso-comment__text'>{formatter ? formatter(text) : text}</div>
        {(date || actions.length > 0) &&
          <div className='viso-comment__meta'>
            {date &&
              <span className='viso-comment__date'>
                {formatDistanceItem(formatDistanceToNow(new Date(date), { addSuffix: true }), true)}
              </span>
            }
            {actions.length > 0 && actions.map((action, index) => (
              <span key={`${action.label}-${index}`} className='viso-comment__action'>
                <button
                  type='button'
                  className={classNames('viso-comment__button', action.color && `viso-text-${action.color}`)}
                  onClick={action.onClick}
                >
                  {action.label}
                </button>
              </span>
            ))}
          </div>
        }
        {commentFooter && <div className='viso-comment__footer'>{commentFooter}</div>}
      </div>
    </div>
  )
}

export default Comment